export interface RevisionInsightsMetric {
    /** All-time total orders of this type for the office. `null` when no metric is cached yet. */
    totalOrders: number | null;
    /** Revision rate over the last 12 months (0..1). `null` when no data is available. */
    revisionRate: number | null;
}

export interface RecentRevisionCase {
    treatmentId: string;
    tinyId?: string | null;
    revisionDate: string | Date;
    reasonCode?: string | null;
    reason?: string | null;
    reasonTranslation?: string | null;
    isManual: boolean;
}

export interface RevisionInsights {
    metric: RevisionInsightsMetric;
    recentCases: RecentRevisionCase[];
}
